(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name crewing.service:CrewScheduleComponentUiHelper
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .service('CrewingSelectionHelper', CrewingSelectionHelper);

    function CrewingSelectionHelper(CrewingHelper, applicationConstants) {
        var self = this;

        var model = {
            timeLineDays: null,
            crewNamesCol: null,
            crewSchedule: null,
            crewScheduleBlockId: null,
            blockType: null,
            activeSelections: {
                DAYS: [],
                CREWS: [],
                CREW_NAMES: [],
                BLOCKS: [],
                DUTY : null,
                ROW : null,
                WEEK : null,
                EXPANDED_CREW_NAME_ROW : null
            },
            elementActionMap: {
                DAY: {
                    CLICK: {
                        1: cancelAllPreviousSelections,
                        2: selectDay,
                        3: selectTimeLineForDays,
                        4: selectCrew,
                        5: selectCrewNamesForSelectedCrews
                    },
                    RIGHT_CLICK: {
                        1: cancelAllPreviousSelectionsForRightClick,
                        2: selectDay,
                        3: selectCrew,
                        4: selectCrewNamesForSelectedCrews,
                        5: selectTimeLineForDays
                    },
                    SHIFT_CLICK: {
                    	1: selectDaysForShift,
                    	2: selectTimeLineForDays,
                    	3: selectCrewNamesForSelectedCrews
                    },
                    CTRL_CLICK : {
                    	1: selectDay,
                    	2: selectCrew,
                    	3: selectTimeLineForDays,
                    	4: selectCrewNamesForSelectedCrews
                    },
                    DROP_OVER: {
                        1: cancelAllPreviousSelections,
                        2: selectCrew,
                        3: selectCrewNamesForSelectedCrews
                    }
                },
                BLOCK: {
                    CLICK: {
                        1: cancelAllPreviousSelections,
                        2: selectBlock,
                        4: selectCrewForSelectedBlocks,
                        5: selectCrewNamesForSelectedCrews,
                        6: selectDayInTimeLineForBlock
                    },
                    CTRL_CLICK: {
                        1: cancelPreviousDaySelections,
                        2: cancelPreviousTimeLineDaySelection,
                        3: cancelPreviousCrewSelection,
                        4: cancelPreviousCrewNameSelection,
                        5: selectBlock,
                        6: selectCrewForSelectedBlocks,
                        7: selectCrewNamesForSelectedCrews,
                        8: selectDayInTimeLineForBlock
                    },
                    EVENT_CLICK: {
                        1: cancelPreviousSelectionForBlockRightClick,
                        2: selectBlock,
                        3: selectRightClickDuty,
                        4: selectCrewForSelectedBlocks,
                        5: selectCrewNamesForSelectedCrews,
                        6: selectDayInTimeLineForBlock,
                        8: selectClickDuty
                    },
                    RIGHT_CLICK: {
                        1: cancelPreviousSelectionForBlockRightClick,
                        2: selectBlock,
                        3: selectRightClickDuty,
                        4: selectCrewForSelectedBlocks,
                        5: selectCrewNamesForSelectedCrews,
                        6: selectDayInTimeLineForBlock
                    },
                    SHIFT_CLICK: {
                        1: cancelPreviousDaySelections,
                        2: cancelPreviousTimeLineDaySelection,
                        3: cancelPreviousCrewSelection,
                        4: cancelPreviousCrewNameSelection,
                        5: selectBlock,
                        6: selectCrewForSelectedBlocks,
                        7: selectAllOtherBlocksInBetween,
                        8: selectCrewForSelectedBlocks,
                        9: selectCrewNamesForSelectedCrews,
                        10: selectDayInTimeLineForBlock
                    }
                },
                CREW: {
                    CLICK: {
                        1: cancelAllPreviousSelections,
                        2: selectClickedCrew,
                        3: selectCrewNamesForSelectedCrews
                    },
                    RIGHT_CLICK: {
                        1: cancelPreviousDaySelections,
                        2: cancelPreviousBlockSelection,
                        3: cancelPreviousTimeLineDaySelection,
                        4: cancelOtherCrewSelectionIfClickOutside,
                        5: selectClickedCrew,
                        6: selectCrewNamesForSelectedCrews
                    },
                    CTRL_CLICK: {
                        1: cancelPreviousDaySelections,
                        2: cancelPreviousBlockSelection,
                        3: cancelPreviousTimeLineDaySelection,
                        4: selectClickedCrew,
                        5: selectCrewNamesForSelectedCrews
                    }
                },
                ROW : {
                    EXPAND : {
                        1 : clearPreviousExpansion,
                        2 : clearPreviousNameExpansion,
                        3 : expandRow,
                        4 : expandCrewNameForExpandedCrew
                    }
                },
                WEEK : {
                    EXPAND : {
                        1: clearPreviousExpansion,
                        2: clearPreviousNameExpansion,
                        3: expandWeek,
                        4: expandCrewNameForExpandedCrew
                    }
                },
                SCHEDULE_BLOCK :{
                    CLICK: {
                        1: cancelAllPreviousSelections,
                        2: selectBlock,
                        4: selectCrewForSelectedBlocks,
                        5: selectCrewNamesForSelectedCrews,
                        6: selectDayInTimeLineForBlock,
                        7: addWeek,
                        8: selectClickDuty
                    },
                    RIGHT_CLICK: {
                        1: cancelPreviousSelectionForBlockRightClick,
                        2: selectBlockDay,
                        3: selectBlock,
                        4: selectRightClickDuty,
                        5: selectCrewForSelectedBlocks,
                        6: selectCrewNamesForSelectedCrews,
                        7: selectDayInTimeLineForBlock,
                        8: addWeek
                    }
                },
                SCHEDULE_DAY:{
                    CLICK: {
                        1: cancelAllPreviousSelections,
                        2: selectDay,
                        3: selectTimeLineForDays,
                        4: selectCrew,
                        5: selectCrewNamesForSelectedCrews,
                        6: addWeek
                    },
                    SHIFT_CLICK: {
                    	1: selectDaysForShift,
                    	2: selectTimeLineForDays,
                    	3: selectCrewNamesForSelectedCrews
                    },
                    RIGHT_CLICK: {
                        1: cancelAllPreviousSelectionsForRightClick,
                        2: selectDay,
                        3: selectCrew,
                        4: selectCrewNamesForSelectedCrews,
                        5: selectTimeLineForDays,
                        6: addWeek
                    }
                }
            }
        };

        self.INTERACTION = {
            CLICK: 'CLICK',
            RIGHT_CLICK: 'RIGHT_CLICK',
            SHIFT_CLICK: 'SHIFT_CLICK',
            CTRL_CLICK: 'CTRL_CLICK',
            DROP_OVER: 'DROP_OVER',
            EXPAND : 'EXPAND',
            EVENT_CLICK:'EVENT_CLICK'
        };

        self.ELEMENT_NAMES = {
            DAY: 'DAY',
            BLOCK: 'BLOCK',
            CREW: 'CREW',
            ROW : 'ROW',
            WEEK: 'WEEK',
            SCHEDULE_BLOCK:'SCHEDULE_BLOCK',
            SCHEDULE_DAY:'SCHEDULE_DAY'
        };


        var getDayIndex = function (day) {
            return _.findIndex(model.activeSelections.DAYS, {'date': day.date});
        };

        var getCrewIndex = function (crew) {
            return _.findIndex(model.activeSelections.CREWS, {'crewId': crew.crewId});
        };

        var getCrewNameIndex = function (crew) {
            return _.findIndex(model.activeSelections.CREW_NAMES, {crewId: crew.crewId});
        };

        var getCrewInfoForBlock = function (block) {
            var events = block.events;
            var crew;
            for (var i = 0; i < events.length; i++) {
                if (!!events[i].crewInfo) {
                    crew = events[i].crewInfo;
                    break;
                }
            }
            return crew;
        };

        var getCrewById = function (crewId) {
            return _.find(model.crewSchedule, {crewId: crewId});
        };

        var getBlockIndex = function (block) {
            var index = -1;
            var obj;
            for (var i = 0; i < model.activeSelections.BLOCKS.length; i++) {
                obj = model.activeSelections.BLOCKS[i];
                if (block == obj) {
                    index = i;
                    break;
                }
            }
            return index;
        };

        var addDay = function (day) {

        	var controlClick = false;
        	if(angular.isDefined(day.userEvent)){
        		if(day.userEvent.ctrlKey){
        			controlClick = true;
        			delete day.userEvent;
        		}
        	}

            if (getDayIndex(day) < 0) {
                day.isSelected = true;
                model.activeSelections.DAYS.push(day);
            } else if (controlClick && getDayIndex(day) > 0){
            	removeDay(day);
            }

        };

        var addCrew = function (crew) {
            if (getCrewIndex(crew) < 0) {
                crew.isSelected = true;
                model.activeSelections.CREWS.push(crew);
            }
        };

        var addBlock = function (block) {
            if (getBlockIndex(block) < 0) {
                block.isSelected = true;
                model.activeSelections.BLOCKS.push(block);
            }
        };

        var addCrewName = function (crew) {
            if (getCrewNameIndex(crew) < 0) {
                crew.isSelected = true;
                model.activeSelections.CREW_NAMES.push(crew);
            }
        };

        var removeDay = function (day) {
            var _index = getDayIndex(day);
            if (_index >= 0) {
                day.isSelected = false;
                model.activeSelections.DAYS.splice(_index, 1);
            }
        };

        var removeCrew = function (crew) {
            var _index = getCrewIndex(crew);
            if (_index >= 0) {
                crew.isSelected = false;
                model.activeSelections.CREWS.splice(_index, 1);
            }
        };

        var removeCrewName = function (crew) {
            var _index = getCrewNameIndex(crew);
            if (_index >= 0) {
                crew.isSelected = false;
                model.activeSelections.CREW_NAMES.splice(_index, 1);
            }
        };

        var removeBlock = function (block) {
            var _index = getBlockIndex(block);
            if (_index >= 0) {
                block.isSelected = false;
                model.activeSelections.BLOCKS.splice(_index, 1);
            }
        };


        /**
         * Action main functions
         */

        function cancelAllPreviousSelections() {
            cancelPreviousDaySelections();
            cancelPreviousCrewSelection();
            cancelPreviousCrewNameSelection();
            cancelPreviousBlockSelection();
            cancelPreviousTimeLineDaySelection();
            cancelPreviousDutySelection();
            clearAllExpansions();
            clearAllWeekExpansions();
            clearAllCrewNameExpansions();
        }

        function cancelAllPreviousSelectionsExceptDuty(){
            cancelPreviousDaySelections();
            cancelPreviousCrewSelection();
            cancelPreviousCrewNameSelection();
            cancelPreviousBlockSelection();
            cancelPreviousTimeLineDaySelection();
            clearAllExpansions();
            clearAllWeekExpansions();
            clearAllCrewNameExpansions();
        }

        function clearPreviousExpansion(){
            if(!!model.activeSelections.ROW){
                if (angular.isDefined(this.crews) && model.activeSelections.ROW.crewId != this.crews.crewId ) {
                    model.activeSelections.ROW.isExpand = false;
                    model.activeSelections.ROW = null;
                }
            }
        }

        function clearPreviousNameExpansion(){
            if (angular.isDefined(this.crews) && !!model.activeSelections.EXPANDED_CREW_NAME_ROW){
                if(model.activeSelections.EXPANDED_CREW_NAME_ROW.crewId !=  this.crews){
                    model.activeSelections.EXPANDED_CREW_NAME_ROW.isExpand = false;
                    model.activeSelections.EXPANDED_CREW_NAME_ROW = null;
                }
            }
        }

        function clearAllExpansions(){
            if(!!model.activeSelections.ROW){
               var expandCrew = model.activeSelections.ROW;
                expandCrew.isExpand = false;
                model.activeSelections.ROW = null;
            }
        }

        function clearAllWeekExpansions(){
            if(!!model.activeSelections.WEEK){
                var expandCrew = model.activeSelections.WEEK[0];
                expandCrew.isExpand = false;
                //model.activeSelections.WEEK = null;
            }
        }

        function clearAllCrewNameExpansions(){
            if(model.activeSelections.EXPANDED_CREW_NAME_ROW){
                model.activeSelections.EXPANDED_CREW_NAME_ROW.isExpand = false;
                model.activeSelections.EXPANDED_CREW_NAME_ROW = null;
            }
        }

        function expandRow(){
            if (angular.isDefined(this.crews)){
                this.crews.isExpand = true;
                model.activeSelections.ROW = this.crews;
            }
        }

        function expandWeek(){
            if (angular.isDefined(this.week)){
                this.week.isExpand = true;
               // model.activeSelections.WEEK = this.week;
            }
        }
        function expandCrewNameForExpandedCrew(){
            if(!!model.activeSelections.ROW && angular.isDefined(this.crews)){
                var tmpCrew = _.find(model.crewNamesCol, {crewId: this.crews.crewId});
                tmpCrew.isExpand = true;
                model.activeSelections.EXPANDED_CREW_NAME_ROW = tmpCrew;
            }
        }

        function cancelAllPreviousSelectionsForRightClick() {
            if (model.activeSelections.DAYS.length > 0) {
                if (angular.isDefined(this.days) && angular.isDefined(this.crews)) {
                    if (getDayIndex(this.days) == -1) {
                        cancelAllPreviousSelections();
                    } else if (getCrewIndex(this.crews) == -1) {
                        cancelAllPreviousSelections();
                    }
                } else {
                    cancelAllPreviousSelections();
                }
            } else {
                cancelAllPreviousSelections();
            }
        }

          function selectBlockDay() {
            if (this.block.evenCode === "SBY" || this.block.evenCode === "HSBY" || this.block.evenCode === "ASBY"){
              model.activeSelections.DAYS.push(this.days);
              model.crewScheduleBlockId = this.block.crewScheduleBlockId;
              model.blockType = "SBY";
            } else {
              model.crewScheduleBlockId = null;
              model.blockType = null;
            }
          }

        function selectDay() {

          model.crewScheduleBlockId = null;
          model.blockType =  null;
            if (angular.isDefined(this.days)) {

            	if(angular.isDefined(this.userEvent)){
            		this.days["userEvent"] =  this.userEvent;
            	}

                addDaysToActiveSelection(this.days);
            }
        }

        function selectDayForCtrlClick () {
            if (angular.isDefined(this.days)) {
                if(model.activeSelections.DAYS.length ==0){
                    addDay(this.days);
                    selectTimeLineForDays.call(this),
                    selectCrew.call(this);
                }else if (getDayIndex(this.days) >= 0){
                    selectCrew.call(this);
                }
            }
        }

        function selectBetweenDays() {
            if (model.activeSelections.DAYS.length > 1) {
                if (model.activeSelections.DAYS[0].dayIndex < model.activeSelections.DAYS[model.activeSelections.DAYS.length - 1].dayIndex) {
                    var firstDayIndex = model.activeSelections.DAYS[0].dayIndex;
                    var lastDayIndex = model.activeSelections.DAYS[model.activeSelections.DAYS.length - 1].dayIndex;
                } else {
                    var firstDayIndex = model.activeSelections.DAYS[model.activeSelections.DAYS.length - 1].dayIndex;
                    var lastDayIndex = model.activeSelections.DAYS[0].dayIndex;
                }

                var subset = _.filter(model.timeLineDays, function (day) {
                    return day.dayIndex > firstDayIndex && day.dayIndex < lastDayIndex
                });

                angular.forEach(subset, function (day) {
                    selectDay.call({days: day});
                });
            }
        }
        function selectBetweenScheduleDays(){
            if (model.activeSelections.DAYS.length > 1) {
                if (model.activeSelections.DAYS[0].dayIndex < model.activeSelections.DAYS[model.activeSelections.DAYS.length - 1].dayIndex) {
                    var firstDayIndex = model.activeSelections.DAYS[0].dayIndex;
                    var lastDayIndex = model.activeSelections.DAYS[model.activeSelections.DAYS.length - 1].dayIndex;
                } else {
                    var firstDayIndex = model.activeSelections.DAYS[model.activeSelections.DAYS.length - 1].dayIndex;
                    var lastDayIndex = model.activeSelections.DAYS[0].dayIndex;
                }

                var subset = _.filter(model.timeLineDays, function (day) {
                    return day.dayIndex > firstDayIndex && day.dayIndex < lastDayIndex
                });

                angular.forEach(model.timeLineDays, function (week) {
                    angular.forEach(week,function(day){
                        if(day.dayIndex > firstDayIndex && day.dayIndex < lastDayIndex){
                            selectDay.call({days: day});
                        }
                    });

                });
            }
        }

        function selectDayForShift() {
            if (angular.isDefined(this.crews)) {
                if (model.activeSelections.CREWS.length == 0 || getCrewIndex(this.crews) >= 0) {
                    selectDay.call(this);
                    selectCrew.call(this);
                    selectBetweenDays()
                }
            }
        }
        function selectDaysForShift(){
            if (angular.isDefined(this.crews)) {
                if (model.activeSelections.CREWS.length == 0 || getCrewIndex(this.crews) >= 0) {
                    selectDay.call(this);
                    selectCrew.call(this);
                    selectBetweenScheduleDays()
                }
            }
        }
        function selectCrew() {
            if (angular.isDefined(this.crews)) {
                addCrewToActiveSelection(this.crews);
            }
        }

        function cancelPreviousDaySelections() {
            var d, i = 0;
            while (model.activeSelections.DAYS.length > 0) {
                d = model.activeSelections.DAYS[i];
                removeDay(d);
            }
        }

        function cancelPreviousSelectionForBlockRightClick() {
            if (model.activeSelections.BLOCKS.length > 0) {
                if (angular.isDefined(this.patterns)) {
                    if (getBlockIndex(this.patterns) == -1) {
                        cancelAllPreviousSelections();
                    }
                }
            } else {
                cancelAllPreviousSelections();
            }
        }

        function cancelPreviousCrewSelection() {
            var crew, i = 0;
            while (model.activeSelections.CREWS.length > 0) {
                crew = model.activeSelections.CREWS[i];
                removeCrew(crew);
            }
        }

        function cancelPreviousCrewNameSelection() {
            var crew, i = 0;
            while (model.activeSelections.CREW_NAMES.length > 0) {
                crew = model.activeSelections.CREW_NAMES[i];
                removeCrewName(crew);
            }
        }

        function cancelPreviousDutySelection(){
            if(model.activeSelections.DUTY !== null){
                model.activeSelections.DUTY.isSelected = false;
                model.activeSelections.DUTY = null;
            }
        }

        function cancelPreviousBlockSelection() {
            var block, i = 0;
            while (model.activeSelections.BLOCKS.length > 0) {
                block = model.activeSelections.BLOCKS[i];
                removeBlock(block);
            }
        }

        function cancelPreviousTimeLineDaySelection() {
            angular.forEach(model.timeLineDays, function (day) {
                day.isSelectedInHeader = false;
            });
        }

        function cancelOtherCrewSelectionIfClickOutside(){
            if (angular.isDefined(this.crews)) {
                var selected = model.activeSelections.CREWS;
                if(!_.find(selected,{crewId : this.crews.crewId})){
                    cancelPreviousCrewSelection();
                    cancelPreviousCrewNameSelection();
                }
            }
        }

        function selectCrewNamesForSelectedCrews() {
            var tmpCrew;
            angular.forEach(model.activeSelections.CREWS, function (crew) {
                tmpCrew = _.find(model.crewNamesCol, {crewId: crew.crewId});
                addCrewName(tmpCrew);
            });
        }

        function selectDayInTimeLineForBlock() {
            var startDate;
            var endDate;
            var dayStringCol;
            angular.forEach(model.activeSelections.BLOCKS, function (block) {
                startDate = block.patternStartDate;
                endDate = block.patternEndDate;
                dayStringCol = [startDate];
                if (startDate !== endDate) {
                    var nextDayLbl = '';
                    var nextD;
                    var moSt = moment(startDate, 'DD/MM/YYYY');
                    while (nextDayLbl != endDate) {
                        nextD = moSt.add(1, 'd');
                        nextDayLbl = nextD.format('DD/MM/YYYY');
                        dayStringCol.push(nextDayLbl);
                    }
                }

                angular.forEach(model.timeLineDays, function (day) {
                    if (dayStringCol.indexOf(day.date) >= 0) {
                        day.isSelectedInHeader = true;
                    }
                })
            });
        }

        function selectCrewForSelectedBlocks() {
            var tmpCrew, crewObj;
            angular.forEach(model.activeSelections.BLOCKS, function (b) {
                if (b.eventType == 'PATTERN') {
                    tmpCrew = getCrewInfoForBlock(b);
                    crewObj = getCrewById(tmpCrew.crewId);
                    addCrew(crewObj);
                }
            });
        }


        function selectTimeLineForDays() {
            angular.forEach(model.activeSelections.DAYS, function (day) {
                day.isSelectedInHeader = true;
            });
        }


        function selectBlock() {
            if (angular.isDefined(this.patterns)) {
                addBlockToActiveSelection(this.patterns);
            }
        }

        function addWeek(week){
            model.activeSelections.WEEK=[];
            model.activeSelections.WEEK.push(this.week);
        };

        function selectRightClickDuty(){
            if (angular.isDefined(this.block)) {
                addDutyToActiveSelection(this.block);
            }
        }
        function selectClickDuty(){
            if (angular.isDefined(this.block)) {
                addDutyToActiveSelection(this.block);
            }
        }

        function selectAllOtherBlocksInBetween() {
            var selectedBlocks = model.activeSelections.BLOCKS;

            var startBlock = selectedBlocks.reduce(function (previous, current) {
                if (previous == null) {
                    return current;
                } else {
                    var last = moment(previous.patternStartDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var now = moment(current.patternStartDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    if (now.isBefore(last)) {
                        return current;
                    } else {
                        return previous;
                    }
                }
            }, null);

            var endBlock = selectedBlocks.reduce(function (previous, current) {
                if (previous == null) {
                    return current;
                } else {
                    var last = moment(previous.patternEndDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var now = moment(current.patternEndDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    if (now.isAfter(last)) {
                        return current;
                    } else {
                        return previous;
                    }
                }
            }, null);

            var blocks;
            var crews = CrewingHelper.getCrews(model.activeSelections.CREWS);
            angular.forEach(crews, function (crew) {
                blocks = CrewingHelper.getBlocksForCrew(crew.crewId, startBlock.patternStartDate, endBlock.patternEndDate);
                angular.forEach(blocks, function (b) {
                    addBlock(b);
                });
            });
        }


        function selectClickedCrew() {
            if (angular.isDefined(this.crews)) {
                var crewObj = getCrewById(this.crews.crewId);
                addCrew(crewObj);
            }
        }

      /**
       *  get selected CrewScheduleBlockIds
       */
        function extractUniqueEvents(obj) {
          const uniquePatternIds = new Set();
          const uniqueCrewScheduleBlocks = [];

          if (obj.events && Array.isArray(obj.events)) {
            for (var i=0; i<obj.events.length; i++) {
              var event = obj.events[i];
              if (
                event && event.crewScheduleBlockId &&
                !uniquePatternIds.has(event.patternId)
              ) {
                uniquePatternIds.add(event.patternId);
                uniqueCrewScheduleBlocks.push(event);
              }
            }
          }

          return uniqueCrewScheduleBlocks;
        }

        function extractCrewScheduleBlocks(blocks){
          var crewSchdBlocks = [];
          for(var i=0; i<blocks.length; i++){
            var csblocks = extractUniqueEvents(blocks[i]);
            crewSchdBlocks = crewSchdBlocks.concat(csblocks);
          }
          return crewSchdBlocks;
        }


      /**
         * Make block or collection of blocks selected
         * @param blocks
         */
        function addBlockToActiveSelection(blocks) {
            if (blocks instanceof Array) {
                angular.forEach(blocks, function (b) {
                    addBlock(b);
                });
            } else {
                addBlock(blocks);
            }
        }


        function addDutyToActiveSelection(duty){
            if(model.activeSelections.DUTY !== null){
                model.activeSelections.DUTY.isSelected = false;
            }
            duty.isSelected = true;
            model.activeSelections.DUTY = duty;
        }


        /**
         * make day or collection of days selected
         * @param days - Day Object or Day Object Collection
         */
        function addDaysToActiveSelection(days) {
            if (days instanceof Array) {
                angular.forEach(days, function (d) {
                    addDay(d);
                });
            } else {
                addDay(days);
            }
        }

        /**
         * make crew or collection of crews selected
         * @param crews - {} or []
         */
        function addCrewToActiveSelection(crews) {
            if (crews instanceof Array) {
                angular.forEach(crews, function (c) {
                    addCrew(c);
                });
            } else {
                addCrew(crews);
            }
        }


        /**
         * Public Api
         *
         */
        self.performAction = function (elementType, actionType, context) {
            if (model.elementActionMap[elementType] && model.elementActionMap[elementType][actionType]) {
                var actionMap = model.elementActionMap[elementType][actionType];
                if (!!actionMap) {
                    angular.forEach(Object.keys(actionMap), function (key) {
                        actionMap[key].call(context);
                    });
                }
            }
        };

        self.addBlockAndSelectTimeInHeader = function (block){
        	addBlockToActiveSelection(block);
        	selectDayInTimeLineForBlock();
        };

        self.getSelectedCrewSchduleBlockId = function () {
          return model.crewScheduleBlockId;
        };

        self.getSelectedDays = function () {
            return model.activeSelections.DAYS;
        };

        self.getSelectedCrews = function () {
            return model.activeSelections.CREWS;
        };

        self.getSelectedBlocks = function () {
            return model.activeSelections.BLOCKS;
        };

        self.getSelectedCrewScheduleBlocks = function() {
          var blocks = model.activeSelections.BLOCKS;
          return extractCrewScheduleBlocks(blocks);
      }

        self.setTimeLineDaysCol = function (days) {
            model.timeLineDays = days;
        };

        self.getTimeLineDaysCol = function () {
            return model.timeLineDays;
        };

        self.crewNamesCol = function (crewNamesCol) {
            model.crewNamesCol = crewNamesCol;
        };

        self.setCrewSchedule = function (crewSchedule) {
            model.crewSchedule = crewSchedule.schedule;
        };

        self.clearSelections = function () {
            cancelAllPreviousSelections();
        };

        self.clearRowExpands = function(){
            clearAllExpansions();
            clearAllCrewNameExpansions();
        };
        self.clearWeekRowExpands= function(){
            clearAllWeekExpansions();
            clearAllCrewNameExpansions();
        };

        self.getSelectedDuty = function(){
            return model.activeSelections.DUTY;
        };
        self.getWeekData = function(){
            return model.activeSelections.WEEK;
        };
    }
}());
